import { getCenter } from 'ol/extent';
import {
  initMapForRecherche,
  loadFeatureForMap,
  reloadFacettes,
} from './carte-util.js';
import { Resultat } from './carto-resultat.js';
import { manageSelectionLinkInHeader } from '../../selection/utils.js';
import { extentMax } from './carte-config.js';
import {
  initCheckBoxTous,
  initInputSearchFacette,
  initOnChangeFacette,
  initOnReset,
} from '../../search/search-utils.js';

/* Éléments DOM */
const filtresAndResultatsEl = document.querySelector(
  '.carte-filtres-resultats',
);
const toggleFermerButton = document.querySelector(
  '.carte-toggle-bouton.fermer',
);
const toggleOuvrirButton = document.querySelector(
  '.carte-toggle-bouton.ouvrir',
);
const searchButton = document.querySelector('.carte-bouton-recherche');
const nbResultatsContainer = document.querySelector('.carte-resultats-nombre');
const resultatsContainer = document.querySelector('.carte-resultats-items');
const resultatsHelperContainer = document.querySelectorAll(
  '.carte-resultats-helper',
);
const filtreButton = document.querySelector(
  '.carte-filtres-bouton-container .bouton.filtre',
);
const resultButton = document.querySelector(
  '.carte-filtres-bouton-container .bouton.result',
);

const divCarteFacettes = document.querySelector('.carte-filtres-items');
const divCarteResultats = document.querySelector('#carteResultats');

filtreButton.addEventListener('click', function () {
  filtreButton.classList.add('toggle');
  divCarteFacettes.classList.remove('non-visible');

  resultButton.classList.remove('toggle');
  divCarteResultats.classList.add('non-visible');
});
resultButton.addEventListener('click', function () {
  switchToResultPanel();
});

function switchToResultPanel() {
  filtreButton.classList.remove('toggle');
  divCarteFacettes.classList.add('non-visible');

  resultButton.classList.add('toggle');
  divCarteResultats.classList.remove('non-visible');
}

/* Panneau de filtre/résultats */
function toggleFiltresResultats() {
  filtresAndResultatsEl.classList.toggle('carte-filtres-resultats-ouvert');
}
toggleOuvrirButton.addEventListener('click', toggleFiltresResultats);
toggleFermerButton.addEventListener('click', toggleFiltresResultats);

/* Comportement des filtres */
let types = [];
document.querySelectorAll('.checkbox-type-dossier').forEach((el) => {
  el.addEventListener('click', () => {
    const values = el.value.split(',');
    if (!el.checked) {
      types = types.filter((a) => values.indexOf(a) === -1);
    } else {
      types = types.concat(values);
    }
    load();
  });
  // On cache les valeurs sélectionnées par défaut
  types = types.concat(el.value.split(','));
});

/* Gestion de la carte */
// ClusterSource de la carte
let clusterSource;
let map;
let selectedResultat;

const headerEl = document.querySelector('#header');
const mapEl = document.querySelector('#carte');

function fitCarte() {
  mapEl.style.height = window.innerHeight - headerEl.clientHeight + 'px';
}

function initCartoResultat(afterInitFn) {
  fitCarte();
  map = initMapForRecherche('carte', {
    onFeatureClicked,
    controls: {
      autourDeMoi: !!navigator.geolocation,
      extentRecentrerVue: extentMax,
    },
  });
  afterInitFn?.(map, loadFeatureForMap, displayResults);
  setSourceFromMap(map);
  // moveend : On s'est déplacé sur la carte (drag/pan/resize)
  map.on('moveend', displayResultsOnMoveEnd);
}

// On s'assure que la carte soit ok si on redimmensionne la viewport avec par exemple le passage du mode portrait au mode paysage sur un smartphone
window.addEventListener('resize', () => {
  mapEl.style.height = undefined;
  map?.updateSize();
});

/** Mise en cache de la Source OpenLayers pour une réutilisation future */
function setSourceFromMap(map) {
  map.getLayers().forEach((layer) => {
    if (layer.get('nom') === 'dossiersLayer') {
      clusterSource = layer.getSource();
    }
  });
}

function getFeaturesInView() {
  const extent = map.getView().calculateExtent();
  return clusterSource.getFeaturesInExtent(extent);
}

function onFeatureClicked(feature) {
  // On ouvre le panneau
  filtresAndResultatsEl.classList.add('carte-filtres-resultats-ouvert');
  // On fabrique un nouveau résultat pour calculer l'id à retrouver en cache
  const res = new Resultat(feature);
  selectResultat(cache[res.id()]);
}

function selectResultat(resultat) {
  // Désélection de l'ancienne feature
  if (selectedResultat && selectedResultat !== resultat) {
    selectedResultat.unselect();
  }
  selectedResultat = resultat;
  selectedResultat.toggleSelected();

  if (selectedResultat.isSelected()) {
    switchToResultPanel();
    filtresAndResultatsEl.scrollTo({
      // -15: valeur arbitraire pour que soit un peu plus joli :)
      top: selectedResultat.element.offsetTop - 15,
      behavior: 'smooth',
    });
  }
}

/* Partie résultat */
const cache = {};

// On n'utilise qu'un seul event qui déléguera le traitement au bon élément
resultatsContainer.addEventListener('click', function (e) {
  // Interruption après ouverture/téléchargement d'un dossier
  if (
    e.target.closest('.lien-dossier') ||
    e.target.closest('.telecharger-bouton')
  ) {
    return;
  }

  const element = e.target.closest('.carte-resultats-item-wrapper');
  if (!element) return;

  const resultat = cache[element.dataset.id];

  // (Dé)Mise en sélection
  if (e.target.closest('.selection-bouton')) {
    resultat.toggleSelection();
    return;
  }

  // Vérification des boutons de carousel
  const prevBtn = e.target.closest('.precedent-bouton');
  if (prevBtn) {
    resultat.previous();
    return;
  }

  const nextBtn = e.target.closest('.suivant-bouton');
  if (nextBtn) {
    resultat.next();
    return;
  }

  // Par défaut
  onResultatClicked(resultat);
});

manageSelectionLinkInHeader();

function onResultatClicked(resultat) {
  map.getView().setCenter(getCenter(resultat.geometry().getExtent()));
  selectResultat(resultat);
}

function displayResultsOnMoveEnd() {
  displayResults({ withRefreshFacettes: true });
}

async function displayResults({ withRefreshFacettes = false } = {}) {
  let features = getFeaturesInView();
  let nbResultats = 0;
  const resultats = features.map((feature) => {
    const features = feature.get('features');
    nbResultats += features.length;
    return new Resultat(feature);
  });
  if (searchLaunched && withRefreshFacettes) {
    await reloadFacettes(map, types, null, true);
    initFacette();
  }
  refreshResultatCount(nbResultats);

  // Récupération des nouveaux éléments à rendre
  const newCache = {};
  const toRender = {};
  resultats.forEach((r) => {
    const id = r.id();
    newCache[id] = r;
    if (!cache[id]) {
      toRender[id] = r;
    } else {
      // OpenLayers gère une feature de cluster par niveau de zoom. Si on change le zoom, on doit s'assurer
      // que la feature associée au résultat soit bien celle visualisée.
      // FIXME : On n'a toujours le problème avec les cluster > 1, faire un layer dédié à ce qui est sélectionné
      // mais il faut en garder une trace ?
      cache[id].maybeUpdateFeature(r.clusterFeature);
    }
  });

  // Nettoyage du cache
  for (let i in cache) {
    if (!newCache[i]) {
      cache[i].remove();
      delete cache[i];
    }
  }

  // Mise à jour du cache
  Object.assign(cache, toRender);
  Object.values(toRender).forEach((r) =>
    resultatsContainer.appendChild(r.render()),
  );

  if (selectedResultat && !cache[selectedResultat.id()])
    selectedResultat = null;
}

function refreshResultatCount(nbResultats) {
  resultatsHelperContainer.forEach(function (elmt) {
    elmt.classList.toggle('non-visible', nbResultats > 0);
  });
  nbResultatsContainer.innerHTML =
    nbResultats === 1 ? '1 résultat' : `${nbResultats} résultats`;
}

/* Loading */
const showLoading = () => {
  const loadingWrapper = document.createElement('div');
  loadingWrapper.id = 'loadingWrapper';

  const loadingElement = document.createElement('div');
  loadingElement.id = 'loading';

  const loadingText = document.createElement('div');
  loadingText.innerText = 'Chargement des résultats en cours...';

  loadingElement.appendChild(loadingText);
  loadingWrapper.appendChild(loadingElement);
  document.querySelector('.carte-wrapper').appendChild(loadingWrapper);

  let discardCallback;
  if (loadingElement.animate != null) {
    const animation = loadingElement.animate(
      [
        { transform: 'translateY(150px) rotateY(-90deg)' },
        { transform: 'translateY(0) rotateY(0)' },
      ],
      {
        duration: 300,
        easing: 'ease-out',
      },
    );
    animation.play();

    discardCallback = () => {
      animation.reverse();
      animation.onfinish = () => loadingWrapper.removeChild(loadingElement);
      animation.play();
    };
  } else {
    // Compatibility fallback, if the browser doesn't support the web animations API
    discardCallback = () => loadingWrapper.removeChild(loadingElement);
  }

  return discardCallback;
};

// pour savoir si on a lancé la recherche au moins une fois
let searchLaunched = false;
/* Recherche */
searchButton.addEventListener('click', load);
function load() {
  searchLaunched = true;
  const discardLoading = showLoading();
  searchButton.disabled = true;
  loadFeatureForMap(map, types, null, true).then(() => {
    discardLoading();
    searchButton.disabled = false;
    displayResults();
    initFacette();
  });
}

function initFacette() {
  const filtersForm = document.querySelector('form.filters');

  if (filtersForm) {
    initCheckBoxTous(filtersForm);

    initOnChangeFacette(filtersForm, load);

    initInputSearchFacette(filtersForm);

    initOnReset(filtersForm, load);
  }
}

export { initCartoResultat, showLoading };
